<script lang="ts">
	import type { Snippet } from "svelte";

	const { aria, children }: { aria: string; children: Snippet } = $props();
</script>

<div class="contents">
	{@render children()}
	{#if aria}
		<!-- Google complains about some generic texts, this is a workaround, a simple aria-label is not enough -->
		<span class="pointer-events-none absolute overflow-hidden opacity-0">{aria}</span>
	{/if}
</div>
